import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {ICompany, IUser} from '../../../../../assets/types/dtoTypes';

@Injectable( {
  providedIn: 'root',
} )
export class SettingsPageService {
  private readonly http = inject(HttpClient);

  private readonly usersUrl = `${environment.apiUrl}/users`;

  private readonly apiUrl = `${environment.apiUrl}/auth`;

  private readonly comapnyUrl = `${environment.apiUrl}/companies`;

  constructor() {
  }


  public getUser( id: string | undefined ): Observable<IUser> {
    const url = `${this.usersUrl}/${id}`;
    return this.http.get<IUser>( url );
  }

  public getCompany( id: string ): Observable<ICompany> {
    const url = `${this.comapnyUrl}/${id}`;
    return this.http.get<ICompany>( url );
  }

  changePassword( currentPassword: string, newPassword: string, confirmNewPassword: string ) {
    return this.http.post( `${this.apiUrl}/change-password`, {
      currentPassword,
      newPassword,
      confirmPassword: confirmNewPassword,
    } );
  }


}

